import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import './index.scss';
import { getTreppCLOEnabled } from '$/store/release-feature-flags/selectors';
import ClientCloAccess from '$/pages/admin/client/client-detail/ClientCloAccess/ClientCloAccess';
import ClientCloDealAccess from '$/pages/admin/client/client-detail/ClientCloAccess/ClientCloDealAccess';

interface IClientCloRootProps {
  isTreppCLOEnabled: boolean;
}

const ClientCloAccessRoot: React.FC<IClientCloRootProps> = props => {
  const { isTreppCLOEnabled } = props;

  if (isTreppCLOEnabled) {
    return <ClientCloDealAccess />;
  }

  return <ClientCloAccess />;
};

const mapStateToProps = (state: AppState) => {
  const { isTreppCLOEnabled } = getTreppCLOEnabled(state);

  return {
    isTreppCLOEnabled,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClientCloAccessRoot);
